import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { AttachmentConfig, NachdigalService } from '@nachdigal';

@Injectable({
  providedIn: 'root'
})
export class AttachmentConfigResolver implements Resolve<AttachmentConfig | null> {
  constructor(private readonly nachdigalService: NachdigalService) {
  }
  resolve(): Observable<AttachmentConfig | null> {
    return this.nachdigalService.getAttachmentConfig();
  }
}
